import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import en from '../locales/en.json';
import ptBR from '../locales/pt-BR.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      'pt-BR': { translation: ptBR },
    },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes output
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  });

// Keep `<html lang>` on the language actually being rendered. `index.html` hard-codes `lang="en"`,
// and nothing was updating it, so a screen reader read the entire pt-BR interface with English
// pronunciation rules — every translated string spoken as if it were misspelled English. It also
// drives hyphenation and the language a translation tool offers. Both bundled languages are LTR, so
// `dir` is deliberately left alone rather than set speculatively.
const syncDocumentLang = () => {
  document.documentElement.lang = i18n.resolvedLanguage ?? i18n.language;
};
syncDocumentLang();
i18n.on('languageChanged', syncDocumentLang);

export default i18n;
